export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_01.b0c04881.jpg";